import type { Image } from '@/lib/core/utils/image';

export function ShopProductListBanner({ image }: { image?: Image }) {
  if (!image?.src) return null;

  return (
    <div className="flex w-full justify-end">
      <div className="relative aspect-328/512 w-[calc(100vw-74px)] overflow-hidden">
        <img alt={image.alt ?? ''} className="absolute inset-0 h-full w-full object-cover" src={image.src} />
        <div className="absolute inset-0 bg-linear-to-b from-[rgba(0,0,0,0.12)] from-0% to-[rgba(0,0,0,0.4)] to-79%" />
      </div>
    </div>
  );
}
